<template lang="pug">
    .post-view-page
        post-view(v-if="post" :post="post" @removed="removed")
</template>

<script>
import postService from '../../services/post-service'

export default {
    name: 'post-view-page',
    props: {
        postId: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            post: null,
        }
    },
    methods: {
        removed() {
            this.$router.push('/')
        },
    },
    created() {
        postService.get(this.postId).then(({data}) => {
            if (data.data.id) {
                this.post = data.data
            } else {
                this.removed()
            }
        })
    }
}
</script>
